import * as React from 'react';
export const IcNetworkDish = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.94 8.47c.04-.153.06-.311.06-.47a2 2 0 00-2-2c-.159 0-.317.02-.47.06L9.77 2.29a1 1 0 00-1.42 0 8 8 0 00-1.69 8.86 2.94 2.94 0 00.42 4.13L5.31 20H5a1 1 0 000 2h8a1 1 0 100-2h-.54l-1.6-4.66a8 8 0 008.85-1.69 1 1 0 000-1.42l-3.77-3.76zM7.44 20L9 16l1.38 4H7.44zM14 4a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6 1 1 0 100 2z'
      fill='currentColor'
    />
  </svg>
);
